import {
    NgModule
} from '@angular/core';
import {
    Routes,
    RouterModule
} from '@angular/router';

const routes: Routes = [{
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
},
{
    path: 'home',
    loadChildren: './home/home.module#HomePageModule'
},
{
    path: 'list',
    loadChildren: './list/list.module#ListPageModule'
},
{
    path: 'events',
    loadChildren: './events/events.module#EventsPageModule'
},
{
    path: 'travel',
    loadChildren: './travel/travel.module#TravelPageModule'
},
{
    path: 'miami',
    loadChildren: './miami/miami.module#MiamiPageModule'
},
{
    path: 'registry',
    loadChildren: './registry/registry.module#RegistryPageModule'
},
{
    path: 'guests',
    loadChildren: './guests/guests.module#GuestsPageModule'
},
{ path: 'profile/:ID', loadChildren: './profile/profile.module#ProfilePageModule' },
{ path: 'about', loadChildren: './about/about.module#AboutPageModule' },
  { path: 'video', loadChildren: './video/video.module#VideoPageModule' },
  { path: 'music', loadChildren: './music/music.module#MusicPageModule' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
